import { ApostleSkill, apostleSkillSchema } from '@apeiron/apostle'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import * as R from 'ramda'

const useFetchApostleSkillJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<ApostleSkill[]>({
    fetchNow,
    path: ENV_CONFIG.JSON_URL.APOSTLE_SKILLS,
    deserialize: async (response: any) => {
      if (!R.isNil(response)) {
        const skills = R.map(data => {
          return apostleSkillSchema.cast(data)
        }, response) as ApostleSkill[]

        return skills
      }

      return []
    }
  })
}

export default useFetchApostleSkillJson
